import { useEffect } from 'react';

/**
 * Signal to the parent modal that the current question cannot be
 * answered until an upstream prerequisite is filled in. Used to
 * disable the modal's Save & Continue action while the associated
 * "please answer the previous …" message is on screen.
 *
 * Always resets the flag to `false` on unmount so navigating away
 * from a blocking question re-enables the primary action.
 */
export const useBlockedSignal = (
  blocked: boolean,
  onBlockedChange?: (blocked: boolean) => void,
): void => {
  useEffect(() => {
    onBlockedChange?.(blocked);
    return () => onBlockedChange?.(false);
  }, [blocked, onBlockedChange]);
};
